<template>
<n-dialog-provider>
  <div id="nav">
    <Header />
  </div>
  <div class="container">
    <router-view v-slot="{ Component }">
        <component :is="Component" />
    </router-view>
  </div>
  </n-dialog-provider>
</template>

<style>
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*}*/
html, body {
  margin: 0;
  height: 100%;
  background-color: #E0E0E0;
}
#nav {
  position: relative;
  z-index: 99;
  width:100%;
 /*padding: 0 30px;*/
  /*background-image: url("https://www.tradedepot.co.nz/skin/frontend/default/sns_i8style/td2016-modifications/images/fern-bg.jpg");*/
  background-color: #fff;
  box-shadow: 5px 4px 9px 6px rgba(204,204,204,0.45);
-webkit-box-shadow: 5px 4px 9px 6px rgba(204,204,204,0.45);
-moz-box-shadow: 5px 4px 9px 6px rgba(204,204,204,0.45);
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.container{
  width: 80%;
  margin: auto;
  background-color: #fff;
  min-height: calc(100vh - 76px); /*800*/
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}


.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.content{
  padding: 1% 5%;
}

.grecaptcha-badge { 
    visibility: block;
}

@media only screen and (max-width: 1440px) {
  body {
  }
  .container{
    width:90%;
    background-color: #fffffd
  }
}


@media only screen and (max-width: 768px) {
  body {
    background-color: #fffffd;
  }
  .container{
    width:100%;
    background-color: #fffffd
  }
}
</style>
<script>
import Header from "./components/header/Header";
import { NDialogProvider } from 'naive-ui';
export default {
  components: {
    Header,
    NDialogProvider,
  }
}
</script>